// extracted by mini-css-extract-plugin
export var anchor = "featuresItemImage-module--anchor--1c049";
export var featuresImageWrapper = "featuresItemImage-module--featuresImageWrapper--f0ad5";